module.exports = __webpack_public_path__ + "static/media/Metting_Room.4131ddb9.png";